import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { AxiosResponse } from "axios";
import { toast } from "react-toastify";
import { Button, Card, CardBody, CardHeader, Container } from "reactstrap";
import Header from "../../../components/Headers/Header";
import { ISelectedFilters } from "../../../types";
import { getEnrolledStudents } from "../../../Services/Reports/ReportService";
import DotsSpinner from "../../../components/Loader/DotsSpinner/DotsSpinner";
import { STATE_OFFICIAL_PATHS } from "../../../routes";
import { ArrowRight } from "react-bootstrap-icons";
import Filter from "../Components/Filter/Filter";

export default function EnrolledStudents() {
  const history = useHistory();
  const session = useSelector((state: any) => state.user.session);
  const [enrolledStudents, setEnrolledStudents] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const fetchEnrolledStudents = useCallback(
    (filters?: ISelectedFilters) => {
      setIsLoading(true);
      getEnrolledStudents(session?.id, filters?.districtId, filters?.blockId)
        .then(
          (response: AxiosResponse) => {
            setEnrolledStudents(response?.data?.data);
          },
          (error) => {
            console.log("Error caught: ", error?.response);
            toast.error(
              "Sorry! Could not generate report. Please try again later."
            );
          }
        )
        .finally(() => setIsLoading(false));
    },
    [session?.id]
  );

  useEffect(() => {
    fetchEnrolledStudents();
  }, [fetchEnrolledStudents]);

  return (
    <React.Fragment>
      <Header />
      <Container className="mt-n7" fluid>
        <Card className="mb-4 mb-xl-0">
          <CardHeader className="border-0">
            <div className="d-flex justify-content-between">
              <h3 className="mb-0 text-muted">
                <i className="fas fa-file-invoice mr-1"></i> Enrolled Students
              </h3>
              <div>
                <div>
                  <Button
                    color="secondary"
                    size="sm"
                    onClick={() => history.push(STATE_OFFICIAL_PATHS.reports)}
                  >
                    Go Back <ArrowRight />
                  </Button>
                </div>
              </div>
            </div>

            {/* <div className="pt-2">
              <Filter
                hasDistrictFilter
                hasBlockFilter
                onSearch={(value) => {
                  fetchEnrolledStudents(value);
                }}
                onClear={() => {
                  fetchEnrolledStudents();
                }}
              />
            </div> */}
          </CardHeader>

          <CardBody>
            {!isLoading ? (
              <div className="d-flex flex-wrap">
                {enrolledStudents?.length !== 0 ? (
                  enrolledStudents?.map((each, index) => (
                    <Card
                      key={index}
                      className="mb-2 mr-2"
                      style={{ maxWidth: "45%" }}
                    >
                      <CardBody className="d-flex flex-column justify-content-start">
                        <div>
                          <h3>{each?.students_count}</h3>
                          <span className="text-muted small">
                            Student Strength
                          </span>
                        </div>
                        {each?.school ? (
                          <span>
                            <span className="font-weight-bold">School:</span>
                            {each?.school}
                          </span>
                        ) : each?.block ? (
                          <span>
                            <span className="font-weight-bold">Block:</span>{" "}
                            {each?.block}
                          </span>
                        ) : each?.district ? (
                          <span>
                            <span className="font-weight-bold">District:</span>{" "}
                            {each?.district}
                          </span>
                        ) : (
                          <></>
                        )}
                      </CardBody>
                    </Card>
                  ))
                ) : (
                  <div className="w-100 d-flex justify-content-center">
                    No data available for selected filters!
                  </div>
                )}
              </div>
            ) : (
              <DotsSpinner />
            )}
          </CardBody>
        </Card>
      </Container>
    </React.Fragment>
  );
}
